/** Правила, формула индекса и расчёт выигрыша — доступны до входа в комнату (п. 9.2 ТЗ). */
import type { ServerInfo } from '@mt/protocol';
import { locale, t, tp } from '../i18n';
import { Dialog } from './Dialog';

export function Rules({ info, onClose }: { info: ServerInfo; onClose: () => void }) {
  const cap = info.commissionCapAntesPerRound;
  // шаг цены по правилам языка: «0,01» / «0.01»
  const tick = new Intl.NumberFormat(locale(), { maximumFractionDigits: 6 }).format(info.tick);
  const capText = cap !== null ? t('lobby.rules.cap', { antes: cap === 1 ? t('lobby.rules.capOne') : tp('lobby.rules.capMany', cap), max: 3 * cap }) : '';
  const commission = [t('lobby.rules.commissionText', { pct: info.commissionBps / 100 }), capText, t('lobby.rules.retained')].filter(Boolean).join(' ');
  return (
    <Dialog title={t('lobby.rules.title')} onClose={onClose} wide>
      <div className="rules">
        <p className="demo-note">{t('lobby.rules.demo')}</p>
        <h3>{t('lobby.rules.indexTitle')}</h3>
        <p>{t('lobby.rules.indexText')}</p>
        <pre className="formula">I(t) = I₀ · (1 + ⅓ · Σ (pᵢ(t) / Bᵢ − 1)),   I₀ = P₀ = {info.indexBase.toFixed(2)}</pre>
        <ul>
          <li>{t('lobby.rules.index1', { tick })}</li>
          <li>{t('lobby.rules.index2')}</li>
          <li>{t('lobby.rules.index3')}</li>
          <li>{t('lobby.rules.index4')}</li>
          <li>{t('lobby.rules.index5')}</li>
        </ul>
        <h3>{t('lobby.rules.flowTitle')}</h3>
        <ol>
          <li>{t('lobby.rules.flow1')}</li>
          <li>{t('lobby.rules.flow2')}</li>
          <li>{t('lobby.rules.flow3')}</li>
          <li>{t('lobby.rules.flow4', { tick })}</li>
          <li>{t('lobby.rules.flow5')}</li>
        </ol>
        <h3>{t('lobby.rules.actionsTitle')}</h3>
        <p>{t('lobby.rules.actionsText', { s: Math.round(info.turnMs / 1000) })}</p>
        <h3>{t('lobby.rules.payoutTitle')}</h3>
        <ul>
          <li>{t('lobby.rules.payout1')}</li>
          <li>{t('lobby.rules.payout2', { tick })}</li>
          <li>{t('lobby.rules.payout3')}</li>
          <li>{t('lobby.rules.payout4')}</li>
          <li>{t('lobby.rules.payout5')}</li>
        </ul>
        <h3>{t('lobby.rules.exampleTitle')}</h3>
        <p>{t('lobby.rules.exampleText')}</p>
        <h3>{t('lobby.rules.commissionTitle')}</h3>
        <p>{commission}</p>
        <h3>{t('lobby.rules.hotkeysTitle')}</h3>
        <p className="mono small">{t('lobby.rules.hotkeys')}</p>
      </div>
    </Dialog>
  );
}
